import styled from 'styled-components'

export const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 100vh;
  position: relative;
`
